import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/owlBranding/philosophy.webp'

export const PhilosophyOwl: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'hero'} />
)
